import { render, staticRenderFns } from "./SocialSharing.vue?vue&type=template&id=92fd091c&"
import script from "./SocialSharing.vue?vue&type=script&lang=js&"
export * from "./SocialSharing.vue?vue&type=script&lang=js&"
import style0 from "./SocialSharing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../nonspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./SocialSharing.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

component.options.__file = "SocialSharing.vue"
export default component.exports